import { extractIntercomArticleId } from "@shared/utils/misc";
import { showIntercomArticle } from "utils/misc.tsx";

const useIntercomArticle = () => {
  const openIntercomArticleInChat = (articleLink?: string) => {
    const articleId = extractIntercomArticleId(articleLink);
    if (articleId) {
      showIntercomArticle(articleId);
    }
  };

  return { openIntercomArticleInChat };
};

export default useIntercomArticle;
